module.exports = __webpack_public_path__ + "img/about_background.a1f95410.png";